module.exports = __webpack_public_path__ + "static/media/za.8bb00964.svg";